import { Subject } from 'rxjs';

const subject = new Subject();

export const createNewOrderTourGuideService = {
    emitReload: val => subject.next(val),
    reload: () => subject.asObservable()
};